'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Counter = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Counter = exports.Counter = function Counter(_ref) {
  var valuePlaceholder = _ref.valuePlaceholder,
      counterLabel = _ref.counterLabel,
      value = _ref.value,
      options = _ref.options;
  return _react2.default.createElement(
    'span',
    null,
    !!value.length ? counterLabel || valuePlaceholder : valuePlaceholder,
    !!value.length && _react2.default.createElement(
      'span',
      { className: 'Header__valueCounter' },
      '(',
      value.length === options.length ? 'All' : value.length,
      ')'
    )
  );
};